import { useCallback, useRef, useState } from 'react';

export function useElementSize<T extends HTMLElement = HTMLElement>() {
    const [size, setSize] = useState({ width: 0, height: 0 });
    const observerRef = useRef<ResizeObserver | null>(null);

    const ref = useCallback((node: T | null) => {
        observerRef.current?.disconnect();
        observerRef.current = null;

        if (!node || typeof ResizeObserver === 'undefined') {
            return;
        }

        const observer = new ResizeObserver(() => {
            const { offsetWidth: width, offsetHeight: height } = node;
            setSize((prev) => (prev.width === width && prev.height === height ? prev : { width, height }));
        });

        observer.observe(node);
        observerRef.current = observer;
    }, []);

    return [ref, size] as const;
}
